// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3wsaG","row":"Node_row__xZnsK","label":"Node_label__39nbw","footer":"Node_footer__1HDsG"};